/* Kundi Pets — Autoplay discreto para los carruseles de productos del Home.
   No crea un carrusel nuevo: usa el <slider-component> de Dawn (assets/global.js)
   y sus propios métodos (setSlidePosition, sliderItemOffset, botón "siguiente").
   - Avanza una tarjeta cada N segundos; al llegar al final vuelve al comienzo.
   - Se pausa con ratón encima, foco, toque, arrastre, rueda o clic en flechas,
     y retoma unos segundos después de la última interacción.
   - Solo corre si el carrusel está visible en pantalla y la pestaña activa.
   - No se activa con prefers-reduced-motion: reduce. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const RESUME_DELAY = 6000;

  const setup = (section) => {
    const slider = section.querySelector('slider-component');
    if (!slider || slider.dataset.kundiAutoplay) return;
    slider.dataset.kundiAutoplay = 'on';

    const interval = (parseInt(section.dataset.autoplaySpeed, 10) || 5) * 1000;
    let timer = null;
    let hovering = false;
    let focused = false;
    let inView = false;
    let pausedUntil = 0;

    const track = () => slider.slider;
    const canScroll = () => track() && track().scrollWidth - track().clientWidth > 4;
    const active = () =>
      !reduceMotion.matches && !document.hidden && inView && !hovering && !focused && Date.now() >= pausedUntil && canScroll();

    const advance = () => {
      if (!active() || !slider.sliderItemOffset) return;
      const t = track();
      const atEnd = slider.nextButton?.hasAttribute('disabled') || t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
      slider.setSlidePosition(atEnd ? 0 : t.scrollLeft + slider.sliderItemOffset);
    };

    const start = () => {
      if (!timer) timer = setInterval(advance, interval);
    };
    const stop = () => {
      clearInterval(timer);
      timer = null;
    };
    const userInteracted = () => {
      pausedUntil = Date.now() + RESUME_DELAY;
    };

    slider.addEventListener('mouseenter', () => (hovering = true));
    slider.addEventListener('mouseleave', () => {
      hovering = false;
      userInteracted();
    });
    slider.addEventListener('focusin', () => (focused = true));
    slider.addEventListener('focusout', () => {
      focused = false;
      userInteracted();
    });
    ['pointerdown', 'touchstart', 'wheel', 'keydown', 'click'].forEach((ev) =>
      slider.addEventListener(ev, userInteracted, { passive: true })
    );

    new IntersectionObserver((entries) => {
      inView = entries.some((e) => e.isIntersecting);
      inView ? start() : stop();
    }, { threshold: 0.4 }).observe(slider);

    reduceMotion.addEventListener?.('change', () => (reduceMotion.matches ? stop() : inView && start()));
  };

  const init = () => document.querySelectorAll('.kundi-products[data-autoplay]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Editor de temas: volver a iniciar cuando se recarga una sección
  document.addEventListener('shopify:section:load', init);
})();
